import React, { useCallback, useState } from "react";

import { useHistory } from "react-router-dom";
import GameVignette from "./gameVignette";

const HomeApp = (props) => {
  const [inputSearch, setInputSearch] = useState("");

  let gamesList = props.gamesList;

  const history = useHistory();

  const selectGame = useCallback(
    (game) => {
      props.setSearchGame(game);
      history.push("/app/search");
    },
    [props, history]
  );

  const searchGame = useCallback((e) => {
    e.preventDefault();
  }, []);

  return (
    <>
      <section className="banner container">
        {gamesList && (
          <div className="banner__content">
            <img
              className="banner__img"
              src={require(`../../../assets/img/${gamesList[4].banner_url}`)}
              alt="banner"
            />
            <div className="banner__infos">
              <span>Nouveau sur Mate</span>
              <h2 className="banner__title">{gamesList[4].game}</h2>
              <p>Le jeu de pirates développé par Rare</p>
              <span className="banner__nbrPost">
                {gamesList[4].nbr_posts} annonce
                {gamesList[4].nbr_posts > 1 && "s"}
              </span>

              <button
                onClick={() => selectGame(gamesList[4])}
                className="banner__discoverBtn"
              >
                Chercher un mate
              </button>
            </div>
          </div>
        )}
      </section>

      <section className="gamesList container">
        <h3 className="gamesList__title">Trouves toi un mate</h3>

        <h4 className="gamesList__subTitle">Choisi un jeu</h4>
        <form onSubmit={(e) => searchGame(e)} className="gamesList__form">
          <label className="visually-hidden">Rechercher un jeu</label>
          <input onChange={(e) => setInputSearch(e.target.value)} type="text" />
          <button className="btn--search" type="submit">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              aria-hidden="true"
              className="svg-inline--fa fa-search fa-w-16"
              data-icon="search"
              data-prefix="fas"
              viewBox="0 0 512 512"
            >
              <path
                fill="currentColor"
                d="M505 442.7L405.3 343c-4.5-4.5-10.6-7-17-7H372c27.6-35.3 44-79.7 44-128C416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208c48.3 0 92.7-16.4 128-44v16.3c0 6.4 2.5 12.5 7 17l99.7 99.7c9.4 9.4 24.6 9.4 33.9 0l28.3-28.3c9.4-9.4 9.4-24.6.1-34zM208 336c-70.7 0-128-57.2-128-128 0-70.7 57.2-128 128-128 70.7 0 128 57.2 128 128 0 70.7-57.2 128-128 128z"
              ></path>
            </svg>
          </button>
        </form>
        <ul className="gamesList__list">
          {gamesList &&
            gamesList.map((game, key) => {
              if (
                !inputSearch.toLowerCase() ||
                game.game.toLowerCase().includes(inputSearch.toLowerCase())
              ) {
                return (
                  <li
                    key={key}
                    onClick={() => selectGame(game)}
                    className="gamesList__el"
                  >
                    <GameVignette game={game} />
                  </li>
                );
              }

              return null;
            })}
        </ul>
      </section>
    </>
  );
};

export default HomeApp;
